import { getQuarter } from 'date-fns/getQuarter';

export const quartal = {
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4',
} as const;
export type Quartal = (typeof quartal)[keyof typeof quartal];

const getQuartalFromQuartalNr = (quartalNr: number): Quartal => {
  switch (quartalNr) {
    case 1:
      return quartal.Q1;
    case 2:
      return quartal.Q2;
    case 3:
      return quartal.Q3;
    case 4:
      return quartal.Q4;
    default:
      throw new Error(`Can't calculate Quartal from Quartal Nr. ${quartalNr}`);
  }
};

export const getQuartalsForDateRange = (
  date1: Date,
  date2: Date,
): {
  quartal: Quartal;
  year: number;
}[] => {
  let start: Date;
  let end: Date;
  if (date1 < date2) {
    start = date1;
    end = date2;
  } else {
    start = date2;
    end = date1;
  }

  const startQuartalNr = getQuarter(start);
  const endQuartalNr = getQuarter(end);

  const startQuartalYear = start.getFullYear();

  const endQuartalYear = end.getFullYear();

  const quartalList = [];

  let quartalCnt = startQuartalNr;
  let yearCnt = startQuartalYear;

  while ((quartalCnt <= endQuartalNr && yearCnt === endQuartalYear) || yearCnt < endQuartalYear) {
    quartalList.push({
      quartal: getQuartalFromQuartalNr(quartalCnt),
      year: yearCnt,
    });

    quartalCnt++;
    if (quartalCnt > 4) {
      quartalCnt = 1;
      yearCnt++;
    }
  }

  return quartalList;
};
